<template lang="pug">
  main
    NavBarPresupuestos
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Presupuestos &nbsp  
        .columns
          .column.is-4
            | Mes de Asignación:
            .field
              .control
                flat-pickr(
                  v-model='periodo'
                  :config="config"
                  class="input"
                )
          .column.is-offset-4.is-3
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Usuario | Articulo',
                  v-model="filter",
                )
          .column.is-1
            router-link.a.button.is-black.is-small.is-rounded(to="/Presupuestos/Nuevo")
              | Nuevo Presupuesto
        .columns
          .column.is-offset-1.is-10
            TablaPresupuestos(:presupuestos="presupuestos")
        .columns.column-blanco 
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBarPresupuestos from './layout/NavBarPresupuestos.vue'
  import TablaPresupuestos from './componentes/TablaPresupuestos'

  import PresupuestosServices from '../../services/inventario/presupuestos'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'

  export default {
    name: 'HomePresupuestos',
    components: { Loader, NavBarPresupuestos, flatPickr, TablaPresupuestos },
    data() {
      return {
        isLoading: true,
        presupuestos: [],
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m',
          altInput: true,
          dateFormat: 'Y-m',
          locale: Spanish, // locale for this instance only          
        },
        periodo: moment().format('YYYY-MM'),
        filter: ''
      }
    },
    watch: {
      periodo() {
        this.getPresupuestos()
      }
    },
    methods: {
      iniciarComponente() {
        this.getPresupuestos()
      },
      getPresupuestos() {
        PresupuestosServices.getPresupuestos(this.periodo)
          .then( data => {
            this.presupuestos = data.map(this.convetirData)
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },
      convetirData (data) {
        return {
          ...data,
          id: parseInt(data.id),
          area: parseInt(data.area),
          estado: parseInt(data.estado)
        }
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },

  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/HomePresupuestos.vue